import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import {
  IAPI_CON001_Request,
  IAPI_CON001_Response,
  IAPI_FAC038_Request,
  IAPI_FAC038_Response,
  IAPI_REP001_Response,
  IAPI_REP002_Request,
  IAPI_REP002_Response,
  IAPI_REP003_Request,
  IAPI_REP003_Response,
  IAPI_RET019_Request,
  IAPI_RET019_Response,
} from "../../../type/apiType";

// 出力結果一覧参照
// 各種統計処理
const httpAPI_REP001 = async (): Promise<IAPI_REP001_Response> => {
  const res = await http.post(ApiUrl.API_REP001);
  return res.data;
};

// 帳票出力要求更新
// API仕様書_各種統計処理
const httpAPI_REP002 = async (
  param: IAPI_REP002_Request
): Promise<IAPI_REP002_Response> => {
  const res = await http.post(ApiUrl.API_REP002, { ...param });
  return res.data;
};
// データダウンロードユーザ更新
// API仕様書_各種統計処理
const httpAPI_REP003 = async (
  param: IAPI_REP003_Request
): Promise<IAPI_REP003_Response> => {
  const res = await http.post(ApiUrl.API_REP003, { ...param });
  return res.data;
};
/**
 * 契約者一覧参照API
 * @return httpAPI_CON001
 */
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};
/**
 * 施設一覧取得API
 * @return httpAPI_FAC038
 */
const httpAPI_FAC038 = async (
  param: IAPI_FAC038_Request
): Promise<IAPI_FAC038_Response> => {
  let res = await http.post(ApiUrl.API_FAC038, {
    ...param,
  });

  return res.data;
};
/**
 * 退職者一覧取得API
 * @return httpAPI_FAC038
 */
const httpAPI_RET019 = async (
  param: IAPI_RET019_Request
): Promise<IAPI_RET019_Response> => {
  let res = await http.post(ApiUrl.API_RET019, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_REP001,
  httpAPI_REP002,
  httpAPI_CON001,
  httpAPI_FAC038,
  httpAPI_RET019,
  httpAPI_REP003,
};
